import makeTable from '../../components/makeTable.jsx';

export const UrlTable = makeTable([
  ['URL', 60],
  ['Outbound', 10],
  ['Impressions', 10],
  ['Bad UX %', 10],
  ['Failed metrics', 10],
]);
